export default __webpack_public_path__ + "static/media/478.bc6e241d.png";